import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ToastComponent } from './toast/toast.component';
import { ToastService } from '../services/toast.service';

@Component({
  selector: 'kros-toasts',
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, ToastComponent],
})
export class ToastsComponent {
  constructor(public toastService: ToastService) {}

  remove(toast: any): void {
    if (toast.onRemove) {
      toast.onRemove();
    }
    this.toastService.remove(toast);
  }
}
